/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The HospitalsidHospital model module.
 * @module model/HospitalsidHospital
 * @version v0.3
 */
export default class HospitalsidHospital {
  /**
   * Constructs a new <code>HospitalsidHospital</code>.
   * @alias module:model/HospitalsidHospital
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>HospitalsidHospital</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/HospitalsidHospital} obj Optional instance to populate.
   * @return {module:model/HospitalsidHospital} The populated <code>HospitalsidHospital</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HospitalsidHospital();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
HospitalsidHospital.prototype.name = undefined;

